import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, inject, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppModule } from '../../../app-module';
import { AuthService } from '../../services/auth.service';
import { User } from '../../class/user.class';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacionesService } from '../../../components/notificacion/General/notificaciones.service';
import { SessionStorageService } from '../../services/sessionl-storage.service';
import { TabsModule } from 'primeng/tabs';
import { PaginOrganos } from '../../class/OrganosXTipo.class';
import { Subscription } from 'rxjs';

@Component({
  selector: 'oaj-organos-itx',
  templateUrl: 'organos.component.html',
  styleUrls: ['organos.component.css'],
  imports: [AppModule, TabsModule],
  providers: [AuthService]
})

export class OrganosComponent implements OnInit {

  @Output()
  AccederICOIJ!: EventEmitter<any>;// = new EventEmitter();
  OrganosOIJLst = signal<any[]>([]);
  registerForm: FormGroup;
  datosFiltrados: any[] = []; // Datos que se mostrarán después de la búsqueda
  paginatedData: any[] = []; // Datos que se mostrarán en la página actual
  currentPage = 1;
  pageSize = 50; // Cantidad de elementos por página
  searchTerm = '';
  Usuario: User = new User;
  isChange = false;
  private activatedRoute = inject(ActivatedRoute);
  private loadingRepresentacion = false;
  private  loadingSupervision = false;
  loading = false;

  private authService: AuthService = inject(AuthService);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private notificacionesService: NotificacionesService = inject(NotificacionesService);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  cuentaConRepresentacion = false;
  lstRequestPaging: PaginOrganos[] = [];
  isCallService = true;
  subscriptions: Subscription[] = [];
  lstRequestPagingSup: PaginOrganos[] = [];
  isCallServiceSup = true;
  subscriptionsSup: Subscription[] = [];

  ItemsTabs = [
    { nombre: 'Supervisión', visible: false },
    { nombre: 'Representación', visible: true }
  ];
  OrganosSupLst = signal<any[]>([]);
  datosFiltradosSup: any[] = [];
  paginatedDataSup: any[] = []; // Datos que se mostrarán en la página actual
  currentPageSup = 1;
  pageSizeSup = 50; // Cantidad de elementos por página
  searchTermSup = '';

  activeTab = signal<string>('Representación');

  get f() { return this.registerForm.controls; }

  constructor() {
    this.AccederICOIJ = new EventEmitter();
    this.registerForm = new FormGroup({
      idOrgano: new FormControl('', Validators.nullValidator)
    });
  }

  ngOnInit(): void {


    this.activatedRoute.params.subscribe(params => {
      //   console.log('Query Params:', params);
      this.isChange = params['isChange'] === 'true' ? true : false;
    });

    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    this.Usuario = currentUser ?? new User();
    const idOrgAux = this.authService.getIdOrganoAux();
    if (idOrgAux > 0) {
      this.ObtenerPaginacion();
    }
    else {
      this.ConsultaOrganos();
    }

    if (this.Usuario.cuentaConSupervision) {
      this.ItemsTabs.find(x => x.nombre === 'Supervisión')!.visible = true;
     // this.ConsultaOrgSupervicion();
     this.ObtenerPaginacionSup();
      this.activeTab.set('Supervisión');
    } else {
      this.activeTab.set('Representación');
      this.ItemsTabs.find(x => x.nombre === 'Supervisión')!.visible = false;
    }

  }

  /**
   * Consulta los órganos disponibles para el usuario, se obtiene el tipo de organismo y el ID de órgano auxiliar del servicio de autenticación, luego se hace una llamada al servicio para obtener los órganos utilizando estos parámetros, si la respuesta es exitosa se actualiza el número de órganos autorizados en el usuario actual, si solo hay un órgano disponible se accede directamente a ese órgano, si hay más de uno se asigna la lista de órganos obtenida a las variables correspondientes para mostrarla en la vista, si ocurre un error durante la consulta se muestra un mensaje de error en la consola
   */
  ConsultaOrganos(): void {
    this.loadingRepresentacion = true;
    this.actualizarLoading();
    const idTypeCourt = this.authService.getTipoOrganismo();
    const idOrgAux = this.authService.getIdOrganoAux();

    this.authService.getOrganosOIJ(idTypeCourt, idOrgAux).subscribe({
      next: (response: any) => {

        if (response.succcess) {

          // Actualiza el número de órganos autorizados en el usuario actual
          const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
          if (currentUser) {
            currentUser.OrganosAutorizados = response.data.length;
            this.sessionStorageService.setItem('currentUser', currentUser);
          }
          //if (response.data.length === 1 && !this.isChange) {
          if (response.data.length === 1 && !this.Usuario.cuentaConSupervision) {
            this.AccederOrgSel(response.data[0]);
            return;
          }
          if (response.data.length === 0) {
            this.ItemsTabs.find(x => x.nombre === 'Representación')!.visible = false;
          }

          this.OrganosOIJLst.set(response.data);
          this.datosFiltrados = this.OrganosOIJLst();
          this.loadingRepresentacion = false;
          this.actualizarLoading();
          this.applyPagination();

        }
        else {
          this.loadingRepresentacion = false;
          this.actualizarLoading();
          //this.changeDetectorRef.detectChanges();
        }
      },
      error: (error) => {
        console.error('error consulta organos:', error.message);
        this.loadingRepresentacion = false;
        this.actualizarLoading();
        //this.changeDetectorRef.detectChanges();
      }
    });

  }

  applyPagination() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedData = this.datosFiltrados.slice(startIndex, endIndex);
    this.changeDetectorRef.detectChanges();
  }

  onPageChange(newPage: number) {
    this.currentPage = newPage;
    this.applyPagination();
  }

  logout() {
    this.authService.logout();
    //this.AccederICOIJ.emit({ logout: true });
  }

  /**
   * Filtra los datos de la lista de órganos según el término de búsqueda
   */
  filterData() {
    if (!this.searchTerm) {
      this.datosFiltrados = this.OrganosOIJLst();
    } else {
      const searchTermLower = this.searchTerm.toLowerCase();
      this.datosFiltrados = this.OrganosOIJLst().filter(item =>
        ['courtId', 'courtName'].some(key =>
          item[key]?.toString().toLowerCase().includes(searchTermLower)
        )
      );
    }
    this.currentPage = 1; // Reset pagination to the first page
    this.applyPagination();
  }

  /**
   * Selecciona un órgano de la lista, se llama a la función AccederOrgSel para acceder al órgano seleccionado
   * @param organo 
   */
  seleccionaOrgano(organo: any): void {

    this.AccederOrgSel(organo);
  }

  /**
   * Accede al órgano seleccionado, se obtiene el usuario actual de la sesión, si se encuentra se actualizan las propiedades relacionadas con el órgano en el usuario, luego se guarda el usuario actualizado en la sesión y se navega a la página de inicio
   * @param organo 
   */
  AccederOrgSel(organo: any) {
    //  console.log('Organo seleccionado en login:', organo);
    const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
    if (currentUser) {
      currentUser.court = organo.courtId;
      currentUser.nameCourt = organo.courtName;
      currentUser.iClasificacionOrganismo = organo.iClasificacionOrganismo;
      currentUser.bajoSupervision = organo.bajoSupervision;
    }
    this.sessionStorageService.setItem('currentUser', currentUser);
    this.router.navigateByUrl('/home');
  }

  /**
   * Carga los totales de notificaciones para un OIJ específico
   * @param oijId 
   * @returns 
   */
  loadNotificationTotals(oijId: number): Promise<number> {
    return new Promise((resolve) => {
      let tot = 0;
      if (oijId === null) {
        console.warn('No se encontro un OIJ seleccionado en sesion.');
        resolve(tot);
      }
      this.notificacionesService.actualizarTotales(oijId).subscribe({
        next: (totales) => {
          tot = totales.totalNoNotificadas ?? 0
          resolve(tot);
        },
        error: (error) => {
          console.error('Error al obtener los totales de notificaciones', error);
          resolve(tot);
        },
      });

    });
  }

  setTab(tabId: string): void {
    this.activeTab.set(tabId);
  }

  /**
   * Consulta los órganos de supervisión disponibles para el usuario, se obtiene el tipo de organismo y el ID de órgano auxiliar del servicio de autenticación, luego se hace una llamada al servicio para obtener los órganos utilizando estos parámetros, si la respuesta es exitosa se actualiza el número de órganos supervisados en el usuario actual, si solo hay un órgano disponible se accede directamente a ese órgano, si hay más de uno se asigna la lista de órganos obtenida a las variables correspondientes para mostrarla en la vista, si ocurre un error durante la consulta se muestra un mensaje de error en la consola
   */
  ConsultaOrgSupervicion(): void {
    this.loadingSupervision = true;
    this.actualizarLoading();
    const idTypeCourt = this.authService.getTipoOrganismo();
    const idOrgAux = this.authService.getIdOrganoAux();


    this.authService.getOrganosSupervision(idTypeCourt, idOrgAux).subscribe({
      next: (response: any) => {

        if (response.succcess) {

          // Actualiza el número de órganos supervisados en el usuario actual
          const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
          if (currentUser) {
            currentUser.OrganosSupervisados = response.data.length;
            this.sessionStorageService.setItem('currentUser', currentUser);
          }

          this.OrganosSupLst.set(response.data);
          this.datosFiltradosSup = this.OrganosSupLst();
          this.loadingSupervision = false;
          this.applyPaginationSup();

        }
        else {
          this.loadingSupervision = false;
          this.actualizarLoading();
          //this.changeDetectorRef.detectChanges();
        }
      },
      error: (error) => {
        console.error('error consulta organos:', error.message);
        this.loadingSupervision = false;
        this.actualizarLoading();
        //this.changeDetectorRef.detectChanges();
      }
    });

  }

  applyPaginationSup() {
    const startIndex = (this.currentPageSup - 1) * this.pageSizeSup;
    const endIndex = startIndex + this.pageSizeSup;
    this.paginatedDataSup = this.datosFiltradosSup.slice(startIndex, endIndex);
    this.changeDetectorRef.detectChanges();
  }

  onPageChangeSup(newPage: number) {
    this.currentPageSup = newPage;
    this.applyPaginationSup();
  }

  /**
 * Filtra los datos de la lista de órganos según el término de búsqueda
 */
  filterDataSup() {
    if (!this.searchTermSup) {
      this.datosFiltradosSup = this.OrganosSupLst();
    } else {
      const searchTermLower = this.searchTermSup.toLowerCase();
      this.datosFiltradosSup = this.OrganosSupLst().filter(item =>
        ['courtId', 'courtName'].some(key =>
          item[key]?.toString().toLowerCase().includes(searchTermLower)
        )
      );
    }
    this.currentPageSup = 1; // Reset pagination to the first page
    this.applyPaginationSup();
  }

  ObtenerPaginacion() {
    this.fnCancelBusq();
    this.loadingRepresentacion = true;
    this.actualizarLoading();
    const idTypeCourt = this.authService.getTipoOrganismo();
    const idOrgAux = this.authService.getIdOrganoAux();
    this.lstRequestPaging = [];
    this.isCallService = true;

    this.authService.getPagOrganosOIJ(idTypeCourt, idOrgAux).subscribe({
      next: (response: any) => {

        if (response.succcess) {
          this.lstRequestPaging = response.data;
          this.CiclarPaginacion();

        }
        else {
          this.loadingRepresentacion = false;
          this.actualizarLoading();
          //this.changeDetectorRef.detectChanges();
        }
      },
      error: (error) => {
        console.error('error consulta organos:', error.message);
        this.loadingRepresentacion = false;
        this.actualizarLoading();
        //this.changeDetectorRef.detectChanges();
      }
    });
  }

  private CiclarPaginacion(): void {
    let peticion = 0;
    if (this.lstRequestPaging && this.lstRequestPaging.length > 0) {
      this.lstRequestPaging?.forEach((item: PaginOrganos) => {
        if (!this.isCallService) {
          return;
        }
        this.ConsultaRecords(item).then((dataOrganos: any[]) => {
          if (dataOrganos != null) {
            // Actualiza el número de órganos autorizados en el usuario actual
            const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
            if (currentUser) {
              currentUser.OrganosAutorizados = dataOrganos.length;
              this.sessionStorageService.setItem('currentUser', currentUser);
            }
            if (dataOrganos.length === 1 && !this.Usuario.cuentaConSupervision) {
              this.AccederOrgSel(dataOrganos[0]);
              return;
            }
            if (dataOrganos.length === 0) {
              this.ItemsTabs.find(x => x.nombre === 'Representación')!.visible = false;
            }
            // this.OrganosOIJLst().push.apply(this.OrganosOIJLst(), dataOrganos);       
            this.OrganosOIJLst().push(...dataOrganos);
            this.OrganosOIJLst().sort((a, b) => b.totalNotificacionesNoNotificadas - a.totalNotificacionesNoNotificadas);
            this.datosFiltrados = this.OrganosOIJLst();
            this.loadingRepresentacion = false;
            this.actualizarLoading();
            this.applyPagination();
          }
          peticion++;
          if (peticion >= this.lstRequestPaging.length) {
            this.loadingRepresentacion = false;
            this.actualizarLoading();
          }

        });

      });
    }
    else {
      // Actualiza el número de órganos autorizados en el usuario actual
      const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
      if (currentUser) {
        currentUser.OrganosAutorizados = 0;
        this.sessionStorageService.setItem('currentUser', currentUser);
      }
      this.ItemsTabs.find(x => x.nombre === 'Representación')!.visible = false;
      //this.loading = this.Usuario.cuentaConSupervision;
      this.loadingRepresentacion = false;
      this.actualizarLoading();
      //this.changeDetectorRef.detectChanges();
    }

  }

  private ConsultaRecords(_requestPagina: PaginOrganos): Promise<any[]> {
    return new Promise((resolve) => {
      const subscription = this.authService.getOrganosOIJPaging(_requestPagina.itypeOrg, _requestPagina.iOrg, _requestPagina.page, _requestPagina.records)
        .subscribe({
          next: (response: any) => {
            if (response.succcess) {
              const lstitem = response.data;
              if (lstitem && lstitem.length > 0) {
                resolve(lstitem);
              }
              else {
                resolve([]);
              }

            }
            else {
              resolve([]);
            }
          },
          error: (error) => {
            console.error('error consulta organos:', error.message);
            resolve([]);
          }
        });
      this.subscriptions.push(subscription);
    });

  }

  fnCancelBusq(): void {
    this.isCallService = false;
    this.loadingRepresentacion = false;
    this.actualizarLoading();
    this.cancelOutstandingRequests();

  }

  cancelOutstandingRequests() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  get totalPages(): number {
    return Math.ceil(this.datosFiltrados.length / this.pageSize);
  }

  goToFirstPage(): void {
    this.onPageChange(1);
  }

  goToLastPage(): void {
    this.onPageChange(this.totalPages);
  }

  get totalPagesSup(): number {
    return Math.ceil(this.datosFiltradosSup.length / this.pageSizeSup);
  }

  goToFirstPageSup(): void {
    this.onPageChangeSup(1);
  }

  goToLastPageSup(): void {
    this.onPageChangeSup(this.totalPagesSup);
  }

  //SUPERVISOR
    ObtenerPaginacionSup() {
    this.fnCancelBusqSup();
     this.loadingSupervision = true;
     this.actualizarLoading();
    const idTypeCourt = this.authService.getTipoOrganismo();
    const idOrgAux = this.authService.getIdOrganoAux();
    this.lstRequestPagingSup = [];
    this.isCallServiceSup = true;

    this.authService.getPagOrganosOIJSup(idTypeCourt, idOrgAux).subscribe({
      next: (response: any) => {

        if (response.succcess) {
          this.lstRequestPagingSup = response.data;
          this.CiclarPaginacionSup();

        }
        else {
          this.loadingSupervision = false;
          this.actualizarLoading();
          //this.changeDetectorRef.detectChanges();
        }
      },
      error: (error) => {
        console.error('error consulta organos:', error.message);
         this.loadingSupervision = false;
        this.actualizarLoading();
        //this.changeDetectorRef.detectChanges();
      }
    });
  }

  private CiclarPaginacionSup(): void {
    let peticion = 0;
    if (this.lstRequestPagingSup && this.lstRequestPagingSup.length > 0) {
      this.lstRequestPagingSup?.forEach((item: PaginOrganos) => {
        if (!this.isCallServiceSup) {
          return;
        }
        this.ConsultaRecordsSup(item).then((dataOrganos: any[]) => {
          if (dataOrganos != null) {

      // Actualiza el número de órganos supervisados en el usuario actual
          const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
          if (currentUser) {
            currentUser.OrganosSupervisados = dataOrganos.length;
            this.sessionStorageService.setItem('currentUser', currentUser);
          }

          this.OrganosSupLst().push(...dataOrganos);
          this.OrganosSupLst().sort((a, b) => b.totalNotificacionesNoNotificadas - a.totalNotificacionesNoNotificadas);
          this.datosFiltradosSup = this.OrganosSupLst();
          this.loadingSupervision = false;
          this.actualizarLoading();
          this.applyPaginationSup();

          }
          peticion++;
          if (peticion >= this.lstRequestPagingSup.length) {
            this.loadingSupervision = false;
            this.actualizarLoading();
          }

        });

      });
    }
    else {
      // Actualiza el número de órganos supervisados en el usuario actual
      const currentUser: User | null = this.sessionStorageService.getItem<User>('currentUser');
      if (currentUser) {
        currentUser.OrganosSupervisados = 0;
        this.sessionStorageService.setItem('currentUser', currentUser);
      }
      this.loadingSupervision = false;
      this.actualizarLoading();
      //this.changeDetectorRef.detectChanges();
    }

  }

  private ConsultaRecordsSup(_requestPagina: PaginOrganos): Promise<any[]> {
    return new Promise((resolve) => {
      const subscription = this.authService.getOrganosOIJPagingSup(_requestPagina.itypeOrg, _requestPagina.iOrg, _requestPagina.page, _requestPagina.records)
        .subscribe({
          next: (response: any) => {
            if (response.succcess) {
              const lstitem = response.data;
              if (lstitem && lstitem.length > 0) {
                resolve(lstitem);
              }
              else {
                resolve([]);
              }

            }
            else {
              resolve([]);
            }
          },
          error: (error) => {
            console.error('error consulta organos:', error.message);
            resolve([]);
          }
        });
      this.subscriptionsSup.push(subscription);
    });

  }

  fnCancelBusqSup(): void {
    this.isCallServiceSup = false;
    this.loadingSupervision = false;
    this.actualizarLoading();
    this.cancelOutstandingRequestsSup();

  }

  cancelOutstandingRequestsSup() {
    this.subscriptionsSup.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.subscriptionsSup = [];
  }

  private actualizarLoading(): void {
  const nuevoLoading =
    this.loadingRepresentacion ||
    this.loadingSupervision;

  if (this.loading !== nuevoLoading) {
    this.loading = nuevoLoading;
    this.changeDetectorRef.markForCheck();
  }
}

}
